import { gql } from "@apollo/client";

export const CreateGD = gql`
    mutation CreateGD($userRentingGroup: UserRentingGroupInput!) {
        createGD(userRentingGroup: $userRentingGroup)
    }
`; 